import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link, Typography } from '@mui/material';

import ContactUsModal from 'components/Modal/modals/ContactUs';
import { Alert } from 'components';

const AccountIsNotSynced = () => {
  const { t } = useTranslation();
  const [isActivatedModalOpen, setIsActivatedModalOpen] = useState(false);
  return (
    <div style={{ margin: '10px 0' }}>
      <ContactUsModal
        open={isActivatedModalOpen}
        onClose={() => setIsActivatedModalOpen(false)}
      />
      <Alert
        variant="standard"
        severity="error"
        title={t('PAGE_LOGIN_UNSYNCHRONIZED_ERROR_TITLE')}
      >
        <div>
          <Trans i18nKey="PAGE_LOGIN_UNSYNCHRONIZED_ERROR">
            <Typography component="span" variant="body2" />
            <Link
              type="button"
              component="button"
              variant="body2"
              sx={{
                cursor: 'pointer',
                display: 'contents'
              }}
              onClick={() => setIsActivatedModalOpen(true)}
            />
            <Typography component="span" variant="body2" />
          </Trans>
        </div>
      </Alert>
    </div>
  );
};

export default AccountIsNotSynced;
